export default __webpack_public_path__ + "static/media/ico_arrow_down.1310eb65.svg";